import { PercentageBreakdownProvider } from './context';
import type {
  PercentageBreakdownItem,
  PercentageBreakdownSize,
  PercentageBreakdownVariant,
} from './types';

export type PercentageBreakdownProps = React.PropsWithChildren<{
  data: PercentageBreakdownItem[];
  size?: PercentageBreakdownSize;
  /**
   * The variant of the PercentageBreakdown.
   * The default variant is default.
   */
  variant?: PercentageBreakdownVariant;
  /**
   * The maximum total used to compute the bar width as a ratio of the data sum.
   * When provided, the bar will fill `sum(data.values) / maxTotal` of the available width.
   * If not provided, the bar always fills 100% of the available width.
   */
  maxTotal?: number;
}>;

/**
 * PercentageBreakdown is a container component that provides context for child components.
 */
export const PercentageBreakdown = ({
  data,
  size,
  variant,
  maxTotal,
  children,
}: PercentageBreakdownProps) => {
  return (
    <PercentageBreakdownProvider
      value={{
        data,
        size,
        variant,
        maxTotal,
      }}
    >
      {children}
    </PercentageBreakdownProvider>
  );
};
PercentageBreakdown.displayName = 'PercentageBreakdown';
